<footer class="site-footer" id="footer-wrap">
  <!-- Wavy top edge -->
  <svg
    class="site-footer__wave"
    viewBox="0 0 1440 80"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    <path d="M0,38 C480,92 960,-8 1440,38 L1440,80 L0,80 Z"></path>
  </svg>

  <div class="site-footer__body">
    <div class="container">
      <div class="row justify-content-between">
        <!-- Levels -->
        <div class="col-lg-4 col-md-6 mb-4 mb-md-0">
          <h4 class="site-footer__levels-title">Niveles</h4>
          <ul class="site-footer__levels">
            <li *ngFor="let level of levelLinks">
              <a [href]="level.url">- {{ level.label }}</a>
            </li>
          </ul>
        </div>

        <!-- Navigation links -->
        <div class="col-lg-4 col-md-6 mb-4 mb-md-0">
          <ul class="site-footer__nav">
            <li *ngFor="let link of navLinks">
              <a [href]="link.url">
                <i class="fas fa-angle-double-right"></i>
                <span>{{ link.label }}</span>
              </a>
            </li>
          </ul>
          <a
            class="site-footer__cuadernito"
            [href]="cuadernitoUrl"
            target="_blank"
            rel="noopener"
          >Acceso a Cuadernito</a>
        </div>

        <!-- Contact info -->
        <div class="col-lg-4 col-md-6">
          <div class="site-footer__contact">
            <p class="site-footer__line">
              <i class="fas fa-map-marker-alt"></i>
              <span>{{ address1 }}<br />{{ address2 }}</span>
            </p>
            <p class="site-footer__line">
              <i class="fas fa-phone-alt"></i>
              <span>{{ phone }}</span>
            </p>
            <a [href]="contactLink" class="site-footer__cta">Contacto</a>
          </div>
        </div>
      </div>

      <!-- Bottom bar -->
      <div class="site-footer__bottom">
        <div class="site-footer__social">
          <span>Seguinos</span>
          <a
            href="https://www.instagram.com/adoratricessf/"
            target="_blank"
            rel="noopener"
            aria-label="Instagram"
          >
            <i class="fab fa-instagram"></i>
          </a>
        </div>

        <p class="site-footer__copy mb-0" *ngIf="faq?.footer">
          <span>{{ faq.footer }}</span>
        </p>
      </div>
    </div>
  </div>
  <!-- footer-wrap close -->
</footer>
<!-- footer close -->
